module.exports = __webpack_public_path__ + "img/5.a9383c24.png";